import React from 'react';
import { Snackbar } from '@mui/material';

import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

const classes = {
    root: {
        top: 9,

    },
    title: {
        fontSize: 18,
    },
    text: {
        fontSize: 15,
    }
};;

export default function Notification(props) {
    const { notify, setNotify } = props;

    const handleClose = (event, reason) => {
        setNotify({
            ...notify,
            isOpen: false
        })
    }

    return (
        <Snackbar
            style={classes.root}
            open={notify.isOpen}
            autoHideDuration={5000 || notify.duration}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            onClose={handleClose}>
            <Alert
                variant="filled"
                severity={notify.type || 'info'}
                onClose={handleClose}>
                <AlertTitle style={classes.title}>{notify.title}</AlertTitle>
                {notify.message}
            </Alert>
        </Snackbar>
    )
}